import { FormControl, FormControlLabel, Stack, Switch } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

import { AnnouncementDialogType } from './AnnouncementDialog.constants';

const AnnouncementDialogScheduling = ({ type }: { type: string }) => {
  const { control, getValues, setValue } = useFormContext();
  const scheduled_at = dayjs(getValues('scheduled_at'));
  const send_email = useWatch({ control, name: 'send_email' });
  const [schedule, setSchedule] = useState(scheduled_at.isValid());

  // if send_email or schedule changes, update the form values
  useEffect(() => {
    setValue('schedule', schedule);
    setValue('scheduled_at', !schedule || !send_email ? null : scheduled_at);
  }, [schedule, send_email]);

  return (
    <Stack>
      <Controller
        control={control}
        name="send_email"
        render={({ field }) => (
          <FormControlLabel
            slotProps={{ typography: { style: { fontWeight: 'bold' } } }}
            control={
              <Switch
                disabled={type === AnnouncementDialogType.VIEW}
                checked={field.value}
                {...field}
              />
            }
            label="Send Email"
          />
        )}
      />
      {send_email && (
        <Stack direction="row">
          <Controller
            control={control}
            name="schedule"
            render={({ field }) => (
              <FormControlLabel
                slotProps={{
                  typography: { style: { fontWeight: 'bold', width: '8rem' } }
                }}
                control={
                  <Switch
                    disabled={type === AnnouncementDialogType.VIEW}
                    checked={schedule}
                    {...field}
                    onChange={() => {
                      setSchedule(!schedule);
                    }}
                  />
                }
                label="Schedule for later"
              />
            )}
          />
          {schedule && (
            <Controller
              disabled={type === AnnouncementDialogType.VIEW}
              control={control}
              name="scheduled_at"
              rules={{
                required: 'Scheduled date is required',
                validate: (value) => value.isValid() || 'Invalid date'
              }}
              render={({ field, formState }) => (
                <FormControl id="scheduled_at-picker" fullWidth>
                  <DateTimePicker
                    {...field}
                    disablePast
                    slotProps={{
                      textField: {
                        error: !!formState.errors.scheduled_at
                      },
                      field: {
                        clearable: true,
                        onClear: () => setValue('scheduled_at', null)
                      }
                    }}
                  />
                </FormControl>
              )}
            />
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default AnnouncementDialogScheduling;
